import { CommonModule } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { RouterModule } from '@angular/router'

import { CyborgUIModule } from '@cyborg-monorepo/common/angular/cyborg-ui'
import {
  BadgeComponent,
  ButtonComponent,
  ButtonMenuComponent,
  CheckboxComponent,
  CodeBlockComponent,
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  ErrorComponent,
  EllipsisComponent,
  IconComponent,
  LinkComponent,
  MarkdownComponent,
  RadioButtonComponent,
  SearchInputComponent,
  TabBarComponent,
  TabComponent,
  TagComponent,
  TextAreaComponent,
  TooltipComponent,
  TypographyComponent,
  MessageComponent,
  BreadcrumbComponent,
  MultiSelectComponent,
  ToggleComponent,
} from '@hyperkit'

import { AnalystNotesComponent } from '../shared/components/analyst-notes/analyst-notes.component'
import { BreadcrumbsComponent } from '../shared/components/breadcrumbs/breadcrumbs.component'
import { CollectionComponent } from '../shared/components/collection/collection.component'
import { CyborgFilterComponent } from '../shared/components/cyborg-filter/cyborg-filter.component'
import { DeploymentQueueComponent } from '../shared/components/deployment-queue/deployment-queue'
import { AddToQuickHuntDialogComponent } from '../shared/components/dialogs/add-to-quick-hunt-dialog/add-to-quick-hunt-dialog.component'
import { AddToTemplateDialogComponent } from '../shared/components/dialogs/add-to-template-dialog/add-to-template-dialog.component'
import { MitreCardComponent } from '../shared/components/mitre-card/mitre-card-component'
import { MitreInfoComponent } from '../shared/components/mitre-info/mitre-info.component'
import { ReferencesComponent } from '../shared/components/references/references.component'
import { ResponseActionsComponent } from '../shared/components/response-actions/response-actions.component'
import { SharedModule } from '../shared/shared.module'

import { DashboardComponent } from './components/filter/components/dashboard/dashboard.component'
import { EmergingComponent } from './components/filter/components/dashboard/emerging/emerging.component'
import { MitreComponent } from './components/filter/components/dashboard/mitre/mitre.component'
import { MyEnvComponent } from './components/filter/components/dashboard/my-env/my-env.component'
import { HuntPackageContentComponent } from './components/filter/components/dashboard/recently-updated/recently-updated.component'
import { FilterComponent } from './components/filter/filter.component'
import { SearchComponent } from './components/filter/search/search.component'
import { DrillDownHuntPackageComponent } from './components/hunt-package/hunt-package.component'
import { DrillDownThreatProfileComponent } from './components/threat-profiles/threat-profiles.component'
import { ResearchComponent } from './research.component'
import { ResearchRoutes } from './research.routing'
import { BreadcrumbsDataService } from './services/breadcrumbs.service'
import { SearchDataService } from './services/search-data.service'
@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ResearchComponent,
    CyborgFilterComponent,
    FilterComponent,
    CollectionComponent,
    EmergingComponent,
    SearchComponent,
    MitreComponent,
    HuntPackageContentComponent,
    MyEnvComponent,
    DashboardComponent,
    DeploymentQueueComponent,
    MitreCardComponent,
    DrillDownHuntPackageComponent,
    DrillDownThreatProfileComponent,
    AddToTemplateDialogComponent,
    AddToQuickHuntDialogComponent,
  ],
  providers: [SearchDataService, BreadcrumbsDataService],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule.forChild(ResearchRoutes),
    CyborgUIModule,
    ButtonComponent,
    IconComponent,
    TooltipComponent,
    TextAreaComponent,
    RadioButtonComponent,
    LinkComponent,
    MarkdownComponent,
    ErrorComponent,
    MessageComponent,
    TypographyComponent,
    ButtonMenuComponent,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
    MultiSelectComponent,
    MessageComponent,
    TabBarComponent,
    TabComponent,
    CheckboxComponent,
    CodeBlockComponent,
    ToggleComponent,
    RadioButtonComponent,
    TagComponent,
    ButtonComponent,
    SearchInputComponent,
    BadgeComponent,
    LinkComponent,
    BreadcrumbComponent,
    EllipsisComponent,
    AnalystNotesComponent,
    MitreInfoComponent,
    ReferencesComponent,
    ResponseActionsComponent,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ResearchModule {}
